import { SupportedLocale } from '../types/languages';

export const supportedLanguages: SupportedLocale[] = [
  {
    value: 'it',
    label: 'Italiano',
    langCode: 'it-IT',
  },
  {
    value: 'en',
    label: 'English',
    langCode: 'en-GB',
  },
];

export type SupportedLanguagesCodes = 'it' | 'en';

export const DEFAULT_LANGUAGE = 'it';
export const DEFAULT_LANGUAGE_CODE = 'it-IT';
